"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PUSHTypes_1 = require("../PUSHTypes");
const PDPSTypes_1 = require("./PDPSTypes");
const PUSHClient_1 = __importDefault(require("../PUSHClient"));
const SubscribeBalance_1 = require("../AAPI/calls/SubscribeBalance");
class PDPSClient extends PUSHClient_1.default {
    constructor(params) {
        super(params);
        this._balance = {};
        this.balanceChangedDelegates = {};
        this._topicHandlersLocal = {
            23: this._onSubscribeBalanceJSON,
        };
        this._regexArrayLocal = [
            {
                regex: /(\d{1,4})\/D\S23$/,
                method: this._onSubscribeBalance,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'subscriptionId',
                },
            },
            {
                regex: /^.*\/P\/([0-9]*)\/B$/,
                method: this._onBalance1,
                converter: {
                    1: 'availableBalance',
                    2: 'withdrawableBalance',
                    3: 'lastUpdatedAt',
                    4: 'currency',
                },
            },
        ];
        this.subscribeBalance = SubscribeBalance_1.subscribeBalance.bind(this);
        this.removeBalanceDelegates = (correlationId) => {
            delete this.balanceChangedDelegates[correlationId];
        };
        this.extendRegex(this._regexArrayLocal);
        this.extendTopicHandlers(this._topicHandlersLocal);
    }
    _onSubscribeBalance({ bodyObject }) {
        this._onSubscribeBalanceJSON(bodyObject);
    }
    _onSubscribeBalanceJSON(bodyObject) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        const subscriptionId = bodyObject.subscriptionId;
        const correlationData = this._correlationData[correlationId];
        if (returnCode === 0) {
            correlationData.callbackOnSuccess.call(this, {
                correlationId,
                subscriptionId,
            });
        }
        else {
            correlationData.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode }));
        }
    }
    getOrCreateSubscribedBalance(punterId, params) {
        this._balance[punterId] = new PDPSTypes_1.SubscribedBalance(params);
        return this._balance[punterId];
    }
    _onBalance1({ bodyObject }) {
        const punterId = 0, //Number(headerMatches[1]),//hardcoded for now - future will have many punter balances
        isNewBalance = this._balance[punterId] === undefined, thisBalance = this.getOrCreateSubscribedBalance(punterId, bodyObject);
        if (!isNewBalance) {
            for (const subscriptionId in this.balanceChangedDelegates) {
                this.balanceChangedDelegates[subscriptionId](thisBalance);
            }
        }
    }
    getBalance() {
        return this._balance[0];
    }
}
exports.default = PDPSClient;
